import React, { Component } from 'react';

import UserList from './UsersList';
//const mySql=require('../mySql/sqlServer');

var config=require('../config');
var request=require('request');
var guiUtils=require('../ApsHtmlGuiUtils');

//var md5=require("md5");
//var sha256=require("crypto-js/sha256");
//var bcrypt=require('bcryptjs');
//var sql=require("../sqlServer");


class UserRightsMan extends Component {
	constructor(props){
		super(props);
		this.state={login:'',hash:'',db:'',connection:'',userRank:'',myAccountSettings:'',usersTable:'', adminsTable:''};
		this.getUserRights=this.getUserRights.bind(this);
	}
	
	
    
	getUserRights()
	{
		let self=this;
		let str=config.sqlServerAddress()+'/gRaw/getUserRights/'
		+"'"+sessionStorage.getItem("u")+"','"+sessionStorage.getItem("p")+"'";
		
		fetch(str,{
			method:'GET'}).then(function(response){
				if(response.status>=400){
					throw new Error("Bad resp");
				}
				return response.json();
			}).then(function(data){
				self.setState({userRank:data[0].rank});
				
			}).catch(err=>{console.log('caught',err);
			});		
			
	}
	
	componentDidMount()
	{
	    this.getUserRights();
	}
	
	render()
	{
		let rank=this.state.userRank;
		
		if(rank=="0")
		{
			return (<div class='text'> Rang = {rank}</div>);
		}
		else if(rank=="2")
		{
			let statut="Inscrit";
			if(rank=="2") statut="Administrateur";
					return (<div id='userRights'><div class='text' >Mon statut :  {statut}</div>
					<br/>
			<UserList rank="0" title="Liste des Inscrits" />
			<br />
			<UserList rank="2" title="Liste des Administrateurs" />
			</div>);
		}
			else return <div>Attendre</div>;	
		
		//ReactDom.render(<PartFinderButton />,document.getElementById('_partFinderButton'));
	}
}

export default UserRightsMan;